import { ProductionOrder } from 'chronos-core-client';

export function getCombinationIcon(productionOrder: ProductionOrder): string {
  if (productionOrder.combinationOrderIdentifier) {
    return productionOrder.isCombinationOrder ? 'pi pi-th-large' : 'pi pi-share-alt';
  } else {
    return '';
  }
}
